module.exports = __webpack_public_path__ + "img/5-2_07.9ce1726e.jpg";